import React from 'react'
import { styled } from '@mui/material/styles'
import { useRouter } from 'next/router'
import { Container } from '@mui/material'
import { StyledDiv } from '@components/atoms/StyledDiv'
import { useGetCompanyInfoQuery } from '@services/cloud/client'
import CompanyInfoView from './CompanyInfoView'
import CompanyMainInfoView from '../CompanyMainInfoView'
import CompanyTabs from '../CompanyTabs'

const PREFIX = 'index'

const classes = {
  root: `${PREFIX}-root`,
}

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {
    marginBottom: theme.spacing(1),
    minHeight: '78vh',
  },
}))

export function CompanyInfo() {
  const router = useRouter()
  const { id } = router.query

  const { data, error, loading } = useGetCompanyInfoQuery({
    variables: {
      args: {
        companyId: id as string,
      },
    },
  })

  if (error) {
    return <Root>404 ページが存在しません</Root>
  }

  if (loading) {
    return null
  }

  if (!data || !data.company) {
    return <div>404 ページが存在しません</div>
  }

  return (
    <div className={classes.root}>
      <StyledDiv>
        <CompanyMainInfoView company={data.company} />
        <CompanyTabs />
        <Container maxWidth="md">
          <CompanyInfoView company={data.company} />
        </Container>
      </StyledDiv>
    </div>
  )
}
